import React from 'react';

const H_COUNT = 12;
const V_COUNT = 8;

export const RushWavyGrid: React.FC = () => {
  const hLines = Array.from({ length: H_COUNT }, (_, i) => {
    const top = `${((i + 1) / (H_COUNT + 1)) * 100}%`;
    return (
      <div
        key={`h-${i}`}
        className="rush-grid-line rush-grid-line-h"
        style={{ top, animationDelay: `${i * -0.5}s` }}
      />
    );
  });

  const vLines = Array.from({ length: V_COUNT }, (_, i) => {
    const left = `${((i + 1) / (V_COUNT + 1)) * 100}%`;
    return (
      <div
        key={`v-${i}`}
        className="rush-grid-line rush-grid-line-v"
        style={{ left, animationDelay: `${i * -0.875}s` }}
      />
    );
  });

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
      {hLines}
      {vLines}
    </div>
  );
};
